import Vue from 'vue'
import VueRouter from 'vue-router'
// import layout from '@/layout/layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'info',
    meta: { noAuth: true },
    component: () => import('@/views/home/info.vue')
  },
  {
    path: '/info2',
    name: 'info2',
    meta: { noAuth: true },
    component: () => import('@/views/home/info2.vue')
  },
  
  
  
  {
    path: '*',
    name: '404',
    meta: { noAuth: true },
    component: () => import('@/views/404.vue')
  }
  
  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
  
// });

export default router